import React from 'react';
import styles from './index.module.less';

const FeatureCard = ({ icon, title, description }) => {
  return (
    <div className={styles.featurecard}>
      <div className={styles.iconwrapper}>
        <img src={icon} alt={title} className={styles.icon} />
      </div>
      <h3 className={styles.title}>{title}</h3>
      <hr className={styles.divider} />
      <p className={styles.description}>{description}</p>
    </div>
  );
};

export default FeatureCard;
